import { render, staticRenderFns } from "./NoResultsPlaceholder.vue?vue&type=template&id=1c8f4509&scoped=true"
var script = {}
import style0 from "./NoResultsPlaceholder.vue?vue&type=style&index=0&id=1c8f4509&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c8f4509",
  null
  
)

export default component.exports